import ResultTable from "../Table/ResultTable";
import ResultRow from "../Table/ResultRow";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBody from "../Table/ResultBody";
import ResultBodyCell from "../Table/ResultBodyCell";
import ShapeFileHelper from "../../Helpers/ShapeFileHelper";
import HecRasHelper from "../../Helpers/HecRasHelper";

export default function ShapeItem({feature}) {

    return (
        <>
            <ResultTable maxWidth={HecRasHelper.getWidth(105)}>
                {
                    Object.keys(feature?.properties).map(prop => {
                        return (
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(30), textAlign: 'start', verticalAlign: 'start', fontWeight: 'bold'}}>
                                    {prop}
                                </ResultHeaderCell>
                                <ResultBodyCell style={{width: HecRasHelper.getWidth(75)}}>
                                    <div dangerouslySetInnerHTML={{__html: feature?.properties[prop]}}/>
                                </ResultBodyCell>
                            </ResultRow>
                        )
                    })
                }
            </ResultTable>
        </>
    )
}

export function ShapeTooltip({labels, feature}) {
    return (
        <ResultTable maxWidth={HecRasHelper.getWidth(105)}>
            {
                labels?.map((prop, idx) => {
                    return (
                        <ResultRow>
                            <ResultHeaderCell style={{width: HecRasHelper.getWidth(30), textAlign: 'start', verticalAlign: 'start', fontWeight: 'bold'}}>{prop}</ResultHeaderCell>
                            <ResultBodyCell style={{width: HecRasHelper.getWidth(75)}}>
                                <div dangerouslySetInnerHTML={{__html: feature?.properties[prop]}}/>
                            </ResultBodyCell>
                        </ResultRow>
                    )
                })
            }
        </ResultTable>
    )
}